/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/counter_intelligence': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 6.5c-3.115 0-4.951 2.703-5.426 3.5.475.797 2.311 3.5 5.426 3.5s4.951-2.703 5.426-3.5c-.475-.797-2.311-3.5-5.426-3.5zm0 4.5a1 1 0 110-2 1 1 0 010 2z"/><path pid="1" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm6.482 10.092a.75.75 0 01-.025.096c-.005.011-.004.024-.01.035-.088.175-2.187 4.277-6.447 4.277s-6.36-4.102-6.447-4.276c-.006-.011-.005-.024-.01-.035a.4.4 0 01-.025-.096c-.006-.032-.013-.062-.013-.093s.007-.061.013-.092a.4.4 0 01.025-.096c.005-.012.004-.024.01-.036C3.64 9.602 5.74 5.5 10 5.5s6.359 4.102 6.447 4.276c.006.011.005.024.01.035.014.031.02.063.025.096.006.031.013.061.013.092s-.007.062-.013.093z"/>'
  }
})
